export default class DateTime {
    /**
     * Constructor
     * @param {Object} element Html element
     */
    constructor(element) {
        this.ticker = null;
        this.el = element;
        this.dateTimeStart();
    }

    /**
     * Starting ticker
     */
    dateTimeStart() {
        this.changeTime();
        this.ticker = setInterval(() => {
            this.changeTime();
        }, 10000);
    }

    /**
     * Changing date string in the main HTML element
     */
    changeTime() {
        const date = new Date();
        this.el.innerHTML = DateTime.formatDate(date);
    }

    /**
     * Convert date object do the formated string
     * @param {Object} Date
     * @returns {String}
     */
    static formatDate(date) {
        const dateArray = date.toString().split(' ');
        const dayName = dateArray[0];
        const dayNum = date.getDate();
        const monthName = dateArray[1];
        const hours = DateTime.zeroFill(date.getHours(), 2);
        const minutes = DateTime.zeroFill(date.getMinutes(), 2);
        return `${dayName} ${dayNum} ${monthName} | ${hours}:${minutes}`;
    }

    /**
     * Padding number with zero, it depends on the width
     * @param {Integer} number
     * @param {Integer} requiredWidth
     */
    static zeroFill(number, requiredWidth) {
        const realWidth = requiredWidth - number.toString().length;
        if (realWidth > 0) {
            return new Array(realWidth + (/\./.test(number) ? 2 : 1)).join('0') + number;
        }
        return number.toString(); // always return a string
    }

}
